module.exports = __webpack_public_path__ + "static/media/vitoria-regia_thumb.ef8ba95a.jpeg";